export default __webpack_public_path__ + "static/media/angpao-bm.93697ec5.webp";